// routes/_app.profile.edit.blocklist.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.profile.edit.blocklist')

export const handle = {
  name: 'profile/edit/blocklist',
  track: { scene: 'profile-edit', section: 'blocklist' },
}

export default dynamic(getClientModule, { ssr: false })
